import React from 'react';
import { Row } from "@shadcn/components/ui/row";
import { Col } from "@shadcn/components/ui/col";
import { Button } from "@shadcn/components/ui/button";
import { Download, Settings } from "lucide-react";
import ReactSelect from "@shadcn/components/ui/react-select";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuCheckboxItem,
} from "@shadcn/components/ui/dropdown-menu";
import { REGION_CODES } from '../../constants/regions';

const supportedRegions = REGION_CODES.filter(region => region !== 'NZ');

const SOHFilterBar = ({
  searchTerm,
  setSearchTerm,
  region,
  setRegion,
  selectedProduct,
  setSelectedProduct,
  selectedStatus,
  setSelectedStatus,
  productOptions,
  statusOptions,
  isExporting,
  loadingState,
  handleExportSOH,
  visibleColumns,
  setVisibleColumns,
  columnOptions
}) => {
  const handleColumnToggle = (columnKey) => {
    setVisibleColumns(prev => ({
      ...prev,
      [columnKey]: !prev[columnKey]
    }));
  };

  return (
    <>
      <Row className="mb-2">
        <Col>
          <Row className="justify-content-between">
            <Col sm="8" className="w-8/12" style={{paddingBottom: 8}}>
              <div className="app-search d-none d-lg-block">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..." 
                    value={searchTerm} 
                    onChange={(e) => setSearchTerm(e.target.value)} 
                  />
                  <span className="bx bx-search-alt"></span>
                </div>
              </div>
            </Col>
            
            {/* Column Visibility and Export Buttons */}
            <Col sm="4" className="flex w-4/12 align-items-center justify-content-end gap-2">
              {/* Column Visibility Dropdown */}
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="outline" size="sm">
                    <Settings className="h-4 w-4 mr-2" />
                    Columns
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-56 max-h-96 overflow-y-auto z-40">
                  {columnOptions.map((column) => (
                    <DropdownMenuCheckboxItem
                      key={column.key}
                      checked={visibleColumns[column.key]}
                      onCheckedChange={() => handleColumnToggle(column.key)}
                    >
                      {column.label}
                    </DropdownMenuCheckboxItem>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>

              {/* Export Button */}
              <Button
                color="success"
                onClick={handleExportSOH}
                disabled={isExporting || !loadingState}
                size="sm"
                className="d-flex align-items-center justify-content-center"
              >
                <Download className="h-4 w-4 mr-2" />
                {isExporting ? 'Exporting...' : 'Export'}
              </Button>
            </Col>
          </Row>

          <Row className="gap-6">
            <Col sm="3" className="sm:w-3/12">
              <div className="select2-container mb-4">
                <label className="control-label">Region</label>
                <ReactSelect
                  className="z-40"
                  options={supportedRegions.map(val => ({ value: val, label: val }))}
                  onChange={val => setRegion(val.value)}
                  value={{ value: region, label: region }}
                />
              </div>
            </Col>

            <Col sm="3" className="sm:w-3/12">
              <div className="select2-container mb-4">
                <label className="control-label">Product</label>
                <ReactSelect
                  className="z-40"
                  options={productOptions}
                  onChange={setSelectedProduct}
                  value={selectedProduct}
                  isClearable
                />
              </div>
            </Col>

            <Col sm="3" className="sm:w-3/12">
              <div className="select2-container mb-4">
                <label className="control-label">Status</label>
                <ReactSelect
                  className="z-40"
                  options={statusOptions}
                  onChange={setSelectedStatus}
                  value={selectedStatus}
                  isClearable
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default SOHFilterBar;
